<template>
  <div class="review">
    <div class="explanation">
      <h2>题目背景：</h2>
      <div>
        <div class="pre-warp" v-html="question.descriptions"></div>
      </div>
    </div>
    <div class="review-type-tab" v-if="isReview">
      <p></p>
      <span :class="{ on: _reviewType === 1 }" @click="_reviewType = 1">我的答案</span>
      <span :class="{ on: _reviewType === 2 }" @click="_reviewType = 2">正确答案</span>
    </div>
    <div class="review-content answer-content">
      <h2>作答区：<span>(请拖动下列选项进行排序)</span></h2>
      <ul v-if="isReview">
        <li v-for="(item, index) in newOptions" :key="index" :data-val="item.value"><span class="sort-icon"></span>{{ item.label }}</li>
      </ul>
      <ul v-else>
        <draggable
          :options="{ animation: 150, ghostClass: 'sortable-ghost', chosenClass: 'chosenClass', scroll: true, scrollSensitivity: 60 }"
          @sort="handleSort"
        >
          <li v-for="(item, index) in newOptions" :key="index" :data-val="item.value"><span class="sort-icon"></span>{{ item.label }}</li>
        </draggable>
      </ul>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    answer: {
      type: String,
      required: true
    },
    // 1-我的答案，2-正确答案
    reviewType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      onHover: '',
      isFirst: true
    }
  },
  computed: {
    // 答案
    answerMark: {
      get() {
        if (this.answer) {
          return JSON.parse(this.answer)
        }
        return this.question.randoms
      },
      set(val) {
        this.$emit('update:answer', val)
      }
    },
    // 回顾试卷类型
    _reviewType: {
      get() {
        return this.reviewType
      },
      set(val) {
        this.$emit('update:reviewType', val)
      }
    },
    // 是否是回顾试卷
    isReview() {
      return this.$route.query.mode === 'review'
    },
    // 重新排序展示
    newOptions() {
      const arr = this.question.options
      // 只在首次进入的排序
      if (!this.isFirst && !this.isReview) {
        return arr
      }
      let order = null
      if (this.answer) {
        order = JSON.parse(this.answer)
      } else {
        order = this.question.randoms
      }
      // 根据随机顺序匹配排序
      arr.sort(function(a, b) {
        return order.indexOf(a.value) - order.indexOf(b.value)
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isFirst = false
      return arr
    }
  },
  created() {
    // 解决火狐拖拽打开新窗口搜索问题
    document.body.ondrop = function(event) {
      event.preventDefault()
      event.stopPropagation()
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 修改a标签的数据
      const domA = document.querySelectorAll('.explanation a')
      domA.forEach(item => {
        if (item.getAttribute('href').indexOf('http') !== 0) {
          item.setAttribute('href', '/' + item.getAttribute('href'))
        }
        console.log(item.getAttribute('href'))
      })
      // 修改img标签的数据
      const domImg = document.querySelectorAll('.explanation img')
      domImg.forEach(item => {
        if (item.getAttribute('src').indexOf('http') !== 0) {
          item.setAttribute('src', '/' + item.getAttribute('src'))
        }
        console.log(item.getAttribute('src'))
      })
    })
  },
  methods: {
    // 开始拖动
    handleStart() {
      this.onHover = ''
      console.log('onHover', this.onHover)
    },
    // 设置答案，根据最新位置重新排序
    handleSort({ to }) {
      const LI_arr = Array.from(to.getElementsByTagName('li'))
      let arr = LI_arr.map(item => {
        return item.dataset.val
      })
      this.answerMark = JSON.stringify(arr)
    }
  }
}
</script>

<style lang="scss" scoped>
.review {
  height: 100%;
  h2 {
    margin-bottom: 10px;
    span {
      font-weight: normal;
      font-size: 14px;
    }
  }
  &-des {
    padding: 13px 20px;
    height: 120px;
    background: #f4f8f9;
    margin-bottom: 10px;
    & > div {
      // height: 45px;
      overflow-y: auto;
      height: 100%;
      color: #666;
    }
  }
  &-content {
    // height: calc(100% - 130px);
    // // height: 100%;
    // background: #f4f8f9;
    // padding: 13px 20px;
    ul {
      height: calc(100% - 34px);
      overflow-y: auto;
      width: 800px;
      margin: 0 auto;
      padding: 0 5%;
    }
    li {
      border-radius: 2px;
      border: 1px solid #25c78b;
      padding: 6px 7px 6px 34px;
      margin-bottom: 10px;
      cursor: pointer;
      line-height: 20px;
      white-space: pre-wrap;
      color: #25c78b;
      background-color: #fff;
      position: relative;
      .sort-icon {
        display: block;
        width: 13px;
        height: 12px;
        background: url('/images/sort.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 10px;
        top: 9px;
      }
      &.chosenClass {
        background-color: #25c78b;
        color: #fff;
        .sort-icon {
          background: url('/images/sort-on.png') no-repeat;
        }
      }
      // &.hover {
      //   background-color: #25c78b;
      //   color: #fff;
      //   .sort-icon {
      //     background: url('/images/sort-on.png') no-repeat;
      //   }
      // }
    }
  }
  .answer-content {
    height: initial;
    min-height: 450px;
  }
}
</style>
